import { render } from "./BlockNomeEmpresarial.vue?vue&type=template&id=07376261"
import script from "./BlockNomeEmpresarial.vue?vue&type=script&lang=js"
export * from "./BlockNomeEmpresarial.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockNomeEmpresarial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07376261"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07376261', __exports__)) {
    console.log('reload')
    api.reload('07376261', __exports__)
  }
  
  module.hot.accept("./BlockNomeEmpresarial.vue?vue&type=template&id=07376261", () => {
    console.log('re-render')
    api.rerender('07376261', render)
  })

}


export default __exports__